import React from "react";
import { t } from "../../../utils/i18n";

const Head = () => (
  <thead class="table-header rounded-top">
    <tr>
      <th>{t("wallets.master_fees.date")}</th>
      <th>{t("wallets.master_fees.amount")}</th>
      <th>{t("wallets.master_fees.type")}</th>
      <th>{t("wallets.master_fees.description")}</th>
      <th>{t("wallets.master_fees.transfer_id")}</th>
      <th>{t("wallets.master_fees.status")}</th>
      <th></th>
    </tr>
  </thead>
);

export default Head;
